/**
 * hushcare-pdp.js
 * ─────────────────────────────────────────────────────────
 * 1. Variant-change price sync (updates product price on
 *    every variant selection, works across most paid themes)
 * 2. Moves the Snap/Mint installment widget below the
 *    Add-to-Cart / Buy buttons area
 * ─────────────────────────────────────────────────────────
 *
 * Add this to your theme.liquid (before </body>) or load it
 * via your product section's schema:
 *   {{ 'hushcare-pdp.js' | asset_url | script_tag }}
 */

(function () {
  'use strict';

  /* ═══════════════════════════════════════════════════════
   * 1. VARIANT PRICE SYNC
   * ═══════════════════════════════════════════════════════
   * Selectors confirmed from Hush theme DevTools:
   *   Sale price  : span.price.price--highlight.price--large.offer_price  → "Rs. 11,522"
   *   MRP/compare : span.price.price--compare.mrp_price                   → "Rs. 14,403"
   *   Regular price wrapper: span.price.regular_price
   */
  var PRICE_SELECTORS = {
    // Sale / current price shown prominently
    current : '.price--highlight.offer_price',

    // Strikethrough MRP / compare-at price
    compare : '.price--compare.mrp_price',

    // Regular price element (shown when no sale)
    regular : '.price.regular_price',

    // "Save X%" badge (contains the discount label)
    saveBadge : '.save_price, .save-badge, .price--save',
  };

  /**
   * formatMoney — mirrors Shopify's | money Liquid filter exactly.
   * Reads shop.money_format from the data-money-format attribute on
   * .hushcare-block (set in the snippet via {{ shop.money_format | escape }}).
   *
   * Supports all Shopify money format tokens:
   *   {{amount}}                              → 2 decimals, comma thousands
   *   {{amount_no_decimals}}                  → no decimals, comma thousands
   *   {{amount_with_comma_separator}}         → 2 decimals, period thousands, comma decimal
   *   {{amount_no_decimals_with_comma_separator}} → no decimals, period thousands
   *   {{amount_with_apostrophe_separator}}    → 2 decimals, apostrophe thousands
   */
  var _moneyFormat = (function () {
    var el = document.querySelector('.hushcare-block[data-money-format]');
    return el ? el.dataset.moneyFormat : 'Rs. {{amount_no_decimals}}';
  })();

  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ',';
    decimal   = decimal   || '.';
    if (isNaN(number) || number === null) return '0';
    number = (number / 1).toFixed(precision);
    var parts  = number.split('.');
    parts[0]   = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var result = parts[0];
    if (precision > 0) result += decimal + parts[1];
    return result;
  }

  function formatMoney(cents, format) {
    format = format || _moneyFormat;
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var token = /\{\{\s*(\w+)\s*\}\}/.exec(format);
    if (!token) return String(cents);
    var value;
    switch (token[1]) {
      case 'amount':
        value = formatWithDelimiters(cents / 100, 2); break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents / 100, 0); break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents / 100, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents / 100, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents / 100, 2, "'"); break;
      default:
        value = formatWithDelimiters(cents / 100, 2);
    }
    return format.replace(token[0], value);
  }

  /* ── Update Hushcare block prices on variant change ── */
  // function updateHushcarePrice(variant) {
  //   // var saleSpan    = document.querySelector('[data-hushcare-sale-price]');
  //   var compareSpan = document.querySelector('[data-hushcare-compare-price]');
  //   if (!saleSpan) return;

  //   saleSpan.textContent = formatMoney(variant.price);

  //   if (compareSpan) {
  //     if (variant.compare_at_price && variant.compare_at_price > variant.price) {
  //       compareSpan.textContent = formatMoney(variant.compare_at_price);
  //       compareSpan.style.display = '';
  //     } else {
  //       compareSpan.style.display = 'none';
  //     }
  //   }
  // }

  function updateHushcarePrice(variant) {
    var compareSpan = document.querySelector('[data-hushcare-compare-price]');
    if (!compareSpan) return;

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      compareSpan.textContent = formatMoney(variant.compare_at_price);
      compareSpan.style.display = '';
    } else {
      compareSpan.style.display = 'none';
    }
  }

  function updatePriceElements(variant) {
    if (!variant) return;

    var saleEl    = document.querySelector(PRICE_SELECTORS.current);
    var compareEl = document.querySelector(PRICE_SELECTORS.compare);
    var regularEl = document.querySelector(PRICE_SELECTORS.regular);
    var saveBadge = document.querySelector(PRICE_SELECTORS.saveBadge);

    var isSale = variant.compare_at_price && variant.compare_at_price > variant.price;

    if (isSale) {
      if (saleEl) {
        var hiddenSpan = saleEl.querySelector('.visually-hidden');
        saleEl.textContent = formatMoney(variant.price);
        if (hiddenSpan) saleEl.prepend(hiddenSpan);
        saleEl.style.display = '';
      }
      if (compareEl) {
        var hiddenCompare = compareEl.querySelector('.visually-hidden');
        compareEl.textContent = formatMoney(variant.compare_at_price);
        if (hiddenCompare) compareEl.prepend(hiddenCompare);
        compareEl.style.display = '';
      }
      if (regularEl) regularEl.style.display = 'none';
      if (saveBadge && variant.compare_at_price) {
        var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
        saveBadge.textContent = 'Save ' + pct + '%';
        saveBadge.style.display = '';
      }
    } else {
      if (regularEl) {
        var hiddenReg = regularEl.querySelector('.visually-hidden');
        regularEl.textContent = formatMoney(variant.price);
        if (hiddenReg) regularEl.prepend(hiddenReg);
        regularEl.style.display = '';
      }
      if (saleEl)    saleEl.style.display    = 'none';
      if (compareEl) compareEl.style.display = 'none';
      if (saveBadge) saveBadge.style.display  = 'none';
    }

    // Always sync Hushcare block to the new variant price
    updateHushcarePrice(variant);
  }

  /* ── Listen for variant changes (covers most themes) ── */

  // Method A: Shopify's native variant change event (Dawn, newer themes)
  document.addEventListener('variant:change', function (e) {
    if (e.detail && e.detail.variant) {
      updatePriceElements(e.detail.variant);
    }
  });

  // Method B: Custom event names used by common paid themes
  var altEvents = [
    'variantSelected',          // Prestige, Motion
    'variant-selected',
    'product:variant-change',   // Impulse, Streamline
    'theme:variant:change',
  ];
  altEvents.forEach(function (evtName) {
    document.addEventListener(evtName, function (e) {
      var v = (e.detail && (e.detail.variant || e.detail.selectedVariant));
      if (v) updatePriceElements(v);
    });
  });

  // Method C: Hush theme — <product-variants> web component
  // ─────────────────────────────────────────────────────────
  // The theme uses .item_link anchors for size (Single/Double/Queen/King)
  // and <select> dropdowns inside .custom-size-selector for length & thickness.
  // The web component updates variantInput.value as a JS property (not an
  // HTML attribute), so MutationObserver on attributes won't fire.
  // Solution: intercept the UI interactions, wait ~100 ms for the component
  // to resolve the new variant, then read input.value and look up the variant.
  (function initHushVariantListeners() {
    // Get product handle from the <product-variants> custom element
    var variantsEl    = document.querySelector('product-variants[handle]');
    var productHandle = variantsEl
      ? variantsEl.getAttribute('handle')
      : (document.querySelector('[data-product-handle]') || {}).dataset && document.querySelector('[data-product-handle]').dataset.productHandle;

    if (!productHandle) return;

    // Resolve the form and hidden variant id input
    var formId       = variantsEl ? variantsEl.getAttribute('form-id') : null;
    var form         = formId
      ? document.getElementById(formId)
      : document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;

    // Cache of all variants — loaded once from AJAX to avoid repeated fetches
    var _variantCache = null;
    var _lastVariantId = null;

    function getVariants(callback) {
      if (_variantCache) { callback(_variantCache); return; }
      fetch('/products/' + productHandle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) {
          _variantCache = product.variants;
          callback(_variantCache);
        })
        .catch(function () {});
    }

    function resolveAndUpdate() {
      // Read the value AFTER the web component has updated it
      var variantId = variantInput.value;
      if (!variantId || variantId === _lastVariantId) return;
      _lastVariantId = variantId;

      // 1. Try window.productJSON (many themes expose this)
      if (window.productJSON && window.productJSON.variants) {
        var v = window.productJSON.variants.find(function (v) {
          return String(v.id) === String(variantId);
        });
        if (v) { updatePriceElements(v); return; }
      }

      // 2. Use AJAX variant cache
      getVariants(function (variants) {
        var v = variants.find(function (v) {
          return String(v.id) === String(variantId);
        });
        if (v) updatePriceElements(v);
      });
    }

    // ── Trigger: .item_link clicks (Single / Double / Queen / King) ──
    document.addEventListener('click', function (e) {
      var link = e.target.closest('.item_link');
      if (!link) return;
      // Wait for the web component to update the hidden input
      setTimeout(resolveAndUpdate, 120);
    });

    // ── Trigger: select dropdowns inside .custom-size-selector ──
    // (length × breadth and thickness)
    document.addEventListener('change', function (e) {
      if (e.target.closest('.custom-size-selector') ||
          e.target.closest('.custom_selector') ||
          e.target.closest('product-variants')) {
        setTimeout(resolveAndUpdate, 120);
      }
    });

    // ── Trigger: any <select> or radio inside the product form ──
    form.addEventListener('change', function (e) {
      setTimeout(resolveAndUpdate, 120);
    });

    // ── Trigger: InputEvent on the hidden input (if component dispatches it) ──
    variantInput.addEventListener('change', resolveAndUpdate);
    variantInput.addEventListener('input',  resolveAndUpdate);

    // ── Fallback: poll the input value every 200 ms while user is active ──
    // Catches any component update that doesn't emit a DOM event at all.
    var _pollTimer = null;
    function startPolling() {
      clearInterval(_pollTimer);
      _pollTimer = setInterval(resolveAndUpdate, 200);
      setTimeout(function () { clearInterval(_pollTimer); }, 3000);
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('product-variants') ||
          e.target.closest('.custom_selector')  ||
          e.target.closest('.item_toggler')) {
        startPolling();
      }
    });
  })();


  /* ═══════════════════════════════════════════════════════
   * 2. SNAP / MINT BLOCK — MOVE BELOW BUY BUTTONS
   * ═══════════════════════════════════════════════════════
   *
   * The Snap/Mint widget is typically injected by their script as a
   * <div> or <snap-placement> / <sezzle-widget> element near the price.
   *
   * Update SNAP_MINT_SELECTOR to match the element your Snap/Mint
   * script creates (check in DevTools after the page loads).
   *
   * Common selectors:
   *   Snapmint : 'snap-placement', '.snapmint-widget', '[data-snapmint]'
   *   Simpl    : 'simpl-buy-now-button', '.simpl-widget'
   *   ZestMoney: '.zestmoney-widget'
   *   Paytail  : '.paytail-widget'
   */
  // Confirmed from Hush theme DevTools:
  // <div class="snap_emi_txt snap_emi_txt_wrapper" id="sm-widget-btn" onclick="startPop()">
  // var SNAP_MINT_SELECTOR = '#sm-widget-btn, .snap_emi_txt_wrapper, .snap_emi_txt';

  /**
   * TARGET_SELECTOR — the element AFTER which the Snap/Mint block
   * will be inserted. This should be your Add-to-Cart button wrapper
   * or the payment buttons container.
   *
   * Update to match your theme:
   *   Dawn     : '.product-form__buttons'
   *   Prestige : '.ProductForm__BuyButtons'
   *   Impulse  : '.product-form--atc'
   *   Generic  : '[data-shopify="payment-button"]' parent
   */
  // ── SNAP/MINT PLACEMENT — DISABLED UNTIL TARGET SELECTOR IS CONFIRMED ──
  // The widget was being moved to a hidden container because the target
  // selector wasn't matching the correct element in this theme.
  //
  // TO ENABLE:
  // 1. In DevTools, right-click the Add To Cart button → Inspect
  // 2. Copy the class of the button AND its parent <div>
  // 3. Set SNAP_MINT_TARGET below to that parent div's selector
  // 4. Remove the "return;" line
  //
  // Example — if DevTools shows:
  //   <div class="product-form__atc-wrapper">
  //     <button class="product-form__submit" name="add">Add To Cart</button>
  //   </div>
  // Then set: var SNAP_MINT_TARGET = '.product-form__atc-wrapper';

  // Confirmed from Hush theme DevTools: div.buy-button-main-wrapper
  // Snap/Mint will be inserted immediately after this wrapper block.
  var SNAP_MINT_TARGET = '.buy-button-main-wrapper';

  function moveSnapMint() {
    var widget = document.querySelector(SNAP_MINT_SELECTOR);
    var target = document.querySelector(SNAP_MINT_TARGET);
    if (!widget || !target) return false;
    // Already correctly placed right after the wrapper?
    if (target.nextElementSibling === widget) return true;
    // Make sure widget is visible, then move it
    widget.style.removeProperty('display');
    target.insertAdjacentElement('afterend', widget);
    widget.style.marginTop = '12px';
    return true;
  }

  function tryMove() { moveSnapMint(); }
  tryMove();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryMove);
  }
  window.addEventListener('load', tryMove);
  [100, 300, 600, 1000, 2000].forEach(function (ms) { setTimeout(tryMove, ms); });
  var snapObserver = new MutationObserver(function (mutations, obs) {
    if (moveSnapMint()) obs.disconnect();
  });
  snapObserver.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { snapObserver.disconnect(); }, 15000);

})();
